import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

import gcalImage1 from './gcal-01.png';
import gcalImage2 from './gcal-02.png';
import gcalImage3 from './gcal-03.png';


const useStyles = makeStyles()(theme => ({
  sectionTitle: {
    fontSize: '16px',
  },
  link: {
    color: theme.palette.text.primary,
  },
  highlight: {
    color: theme.palette.secondary.main,
  }
}));


export const GoogleCalendarICSInstruction: React.VFC = () => {
  const { classes } = useStyles();

  return (
    <Box display="flex" flexDirection="column">
      <Box p={3} bgcolor="grey.50">
        <Typography variant="h6">How to Sync Google Calendar</Typography>
        <Box mt={1}>
          <Typography variant="body1" color="textSecondary">
            Import your Google Calendar in 3 easy steps. For detailed instructions, <a href="https://help.joinuplift.co/en/articles/8557057-how-to-import-your-google-calendar" target="_blank" className={classes.link} rel="noreferrer">visit our help article</a>.
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box p={3}>
        <Box mt={3}>
          <Typography variant="h6" className={classes.sectionTitle}>1. Find your sharing settings</Typography>
          <Box ml={2}>
            <Typography variant="body1">From the calendar sidebar, find the calendar you want to import then click the 3 dots next to it. Select <strong className={classes.highlight}>Settings and sharing</strong>.</Typography>
            <Box display="flex" justifyContent="center" mt={0.5}>
              <img src={gcalImage1} alt="hello" width="66%" />
            </Box>
          </Box>
        </Box>
        <Box mt={3}>
          <Typography variant="h6" className={classes.sectionTitle}>2. Find the right URL</Typography>
          <Box ml={2}>
            <Typography variant="body1">From your settings sidebar, select <strong className={classes.highlight}>Integrate calendar</strong> to jump to your calendar URLs. You’ll need the one labeled <strong className={classes.highlight}>Secret address in iCal format</strong>.</Typography>
            <Box display="flex" justifyContent="center" mt={0.5}>
              <img src={gcalImage2} alt="hello" width="66%" />
            </Box>
            <Typography variant="body1">Can’t find “Secret address in iCal format”? Your calendar may be tied to an organization that turned off sharing settings. Ask your Workspace admin for help.</Typography>
          </Box>
        </Box>
        <Box mt={3}>
          <Typography variant="h6" className={classes.sectionTitle}>3. Copy and paste your URL</Typography>
          <Box ml={2}>
            <Typography variant="body1">Click the clipboard icon to copy your URL. You’ll receive a security warning. Select <strong className={classes.highlight}>OK</strong> to copy the URL. Return here to your UpLift Schedule set up and past it.</Typography>
            <Box display="flex" justifyContent="center" mt={0.5}>
              <img src={gcalImage3} alt="hello" width="100%" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
